import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Al cambiar de ruta sube al inicio; si la URL trae #seccion, baja a esa sección
const ScrollManager = () => {
  // key cambia en cada navegación, aunque se vuelva a tocar el mismo link
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const frame = requestAnimationFrame(() => {
      document.getElementById(hash.slice(1))?.scrollIntoView();
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash, key]);

  return null;
};

export default ScrollManager;
